import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaBars, FaTimes, FaMoon, FaSun } from "react-icons/fa";
import { useTheme } from "../../context/ThemeContext";
import { navLinks, personalInfo } from "../../data/portfolioData";
import { useLanguage } from "../../context/LanguageContext";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { darkMode, toggleTheme } = useTheme();
  const { language, setLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    const handleResize = () => {
      if (window.innerWidth > 768) setIsOpen(false);
    };

    document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("resize", handleResize);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("resize", handleResize);
    };
  }, [isOpen]);

  const closeMobileMenu = () => setIsOpen(false);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__container">
        <Link
          to="home"
          smooth={true}
          duration={500}
          className="navbar__logo"
          onClick={closeMobileMenu}
        >
          &lt;{personalInfo.name.split(" ")[0]} /&gt;
        </Link>

        <div id="primary-navigation" className={`navbar__menu ${isOpen ? "navbar__menu--active" : ""}`}>
          {navLinks.map((link) => (
            <Link
              key={link.id}
              to={link.id}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              className="navbar__link"
              activeClass="navbar__link--active"
              onClick={closeMobileMenu}
            >
              {t.nav[link.id]}
            </Link>
          ))}
        </div>

        <div className="navbar__actions">
          <div className="navbar__language" role="group" aria-label={t.language}>
            {["en", "fr"].map((code) => (
              <button
                key={code}
                type="button"
                className={`navbar__language-option${language === code ? " navbar__language-option--active" : ""}`}
                onClick={() => setLanguage(code)}
                aria-pressed={language === code}
                aria-label={code === "en" ? "English" : "Français"}
              >
                {code.toUpperCase()}
              </button>
            ))}
          </div>
          <button
            className="navbar__theme-toggle"
            onClick={toggleTheme}
            aria-label={`Switch to ${darkMode ? "light" : "dark"} theme`}
            aria-pressed={darkMode}
          >
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>

          <button
            className="navbar__mobile-toggle"
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isOpen}
            aria-controls="primary-navigation"
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
